import { SelectItem } from 'primereact/selectitem';
import { LabelledSearchRequestSort } from '../util/types';

export const userRoles: string[] = ['ROLE_USER', 'ROLE_EDITOR', 'ROLE_ADMIN'];
export const mandants: string[] = ['rub', 'tudo', 'hhu', 'uwh', 'ril'];
export const languages: string[] = ['de', 'en'];
export const entityTypes: string[] = ['organisation', 'project', 'person', 'work'];
export const externalIdEntityTypes: string[] = ['orga', 'project', 'person', 'work', 'funder'];

export enum ProjectRelationType {
  CHILD = 'child',
  PARENT = 'parent',
  PARTNER = 'partner',
  PREDECESSOR = 'predecessor',
  SUCCESSOR = 'successor',
}

export enum OrganisationRelationType {
  CHILD = 'child',
  PARENT = 'parent',
  PREDECESSOR = 'predecessor',
  SUCCESSOR = 'successor',
}

export enum FacetType {
  SELECT = 'select',
  BOOLEAN = 'boolean',
  DYNAMIC_SELECT = 'dynamic-select',
  DATE_RANGE = 'date-range',
}

export enum HierarchyEntity {
  ORGS = 'orgs',
  PROJECTS = 'projects',
}

export const workFormPages: string[] = ['basic', 'specific', 'ids', 'persons', 'ispartof', 'haspart', 'organisations', 'projects', 'events', 'content', 'administrative'];

export const workFields: string[] = ['id', 'title', 'subtitle', 'other_title', 'title_supplement', 'person', 'person_other', 'organisation', 'organisation_other', 'project', 'project_other', 'date', 'issued', 'publication_status', 'url', 'external_id', 'institutional_id', 'language', 'description', 'subject', 'keyword', 'note', 'format', 'medium', 'related_identifier', 'license', 'license_text', 'date_changed', 'date_created', 'origin', 'deskman', 'orcid_sync', 'hidden', 'editorial_status', 'belong_to_organisation', 'belong_to_project', 'funded', 'article_processing_charge', 'access_level', 'license_management_status', 'obligatory_delivery', 'is_part_of', 'is_part_of_other', 'pubtype', 'form_subject', 'version', 'number_of_pages', 'peer_reviewed', 'place', 'edition', 'number', 'event_start_date', 'event_end_date', 'event_numbering', 'event_name', 'event_place', 'volume', 'has_part', 'publisher', 'number_of_volumes', 'patent_id', 'publication_number', 'priority_number', 'priority_patent_application', 'priority_country', 'application_number', 'application_country', 'grant_number', 'patent_family', 'title_abbreviation', 'subseries_title', 'resource_type', 'size', 'dataversion', 'geo_location'];
export const pubtypes: string[] = ['audio_video_document', 'radio_tv', 'research_data', 'patent', 'newspaper', 'journal', 'chapter', 'chapter_in_conference', 'chapter_in_legal_commentary', 'article_newspaper', 'article_journal', 'article_integrating_resource', 'lexicon_article', 'editorial', 'article_overview', 'blog', 'website', 'monograph', 'collection', 'edition', 'conference', 'legal_commentary', 'special_issue', 'series', 'student_thesis', 'dissertation', 'habilitation', 'multi_volume_work', 'monograph_mvw', 'collection_mvw', 'edition_mvw', 'conference_mvw', 'report_grey_literature', 'review', 'interview', 'lecture', 'poster', 'abstract', 'report_collection'];
export const pubtypeGroups: string[] = ['self_contained', 'self_contained_or_fragment', 'fragment', 'multi_volume_work', 'series', 'integrating_resource', 'periodical', 'research_data_group', 'audio_video_object', 'patent', 'thesis'];

export const publistSortOptions: SelectItem[] = [
  {value: 'stm', label: 'publig.publist.pubsort.style.stm.label'},
  {value: 'anh', label: 'publig.publist.pubsort.style.anh.label'},
];

export const personsSortOptions: LabelledSearchRequestSort[] = [
  {value: {field: 'recordCreationDate', direction: 'asc'}, label: 'sorting.create_date_asc'},
  {value: {field: 'recordCreationDate', direction: 'desc'}, label: 'sorting.create_date_desc'},
  {value: {field: 'recordChangeDate', direction: 'asc'}, label: 'sorting.changed_date_asc'},
  {value: {field: 'recordChangeDate', direction: 'desc'}, label: 'sorting.changed_date_desc'},
];

export const organisationsSortOptions: LabelledSearchRequestSort[] = [
  {value: {field: 'recordCreationDate', direction: 'asc'}, label: 'sorting.create_date_asc'},
  {value: {field: 'recordCreationDate', direction: 'desc'}, label: 'sorting.create_date_desc'},
  {value: {field: 'recordChangeDate', direction: 'asc'}, label: 'sorting.changed_date_asc'},
  {value: {field: 'recordChangeDate', direction: 'desc'}, label: 'sorting.changed_date_desc'},
];
export const projectsSortOptions: LabelledSearchRequestSort[] = [
  {value: {field: 'recordCreationDate', direction: 'asc'}, label: 'sorting.create_date_asc'},
  {value: {field: 'recordCreationDate', direction: 'desc'}, label: 'sorting.create_date_desc'},
  {value: {field: 'recordChangeDate', direction: 'asc'}, label: 'sorting.changed_date_asc'},
  {value: {field: 'recordChangeDate', direction: 'desc'}, label: 'sorting.changed_date_desc'},
];
export const worksSortOptions: LabelledSearchRequestSort[] = [
  {value: {field: 'f_issued', direction: 'asc'}, label: 'sorting.publish_date_asc'},
  {value: {field: 'f_issued', direction: 'desc'}, label: 'sorting.publish_date_desc'},
  {value: {field: 'recordCreationDate', direction: 'asc'}, label: 'sorting.create_date_asc'},
  {value: {field: 'recordCreationDate', direction: 'desc'}, label: 'sorting.create_date_desc'},
  {value: {field: 'recordChangeDate', direction: 'asc'}, label: 'sorting.changed_date_asc'},
  {value: {field: 'recordChangeDate', direction: 'desc'}, label: 'sorting.changed_date_desc'},
];
export const worksSortOptionsProfile: LabelledSearchRequestSort[] = [
  ...worksSortOptions,
  {value: {field: 'projectsChecked', direction: 'asc'}, label: 'sorting.projects_checked_asc'},
  {value: {field: 'projectsChecked', direction: 'desc'}, label: 'sorting.projects_checked_asc'},
];
